<template>
  <div>
    <!--pages/login/login.wxml-->
    <!-- <text>pages/login/login.wxml</text> -->
    <div class="login">
      <div class="login_top">
        <img class="login_topimg" src="/static/logo.png" />
        <!-- <div class="login_name">番茄服务商家端</div> -->
      </div>
      <div class="testbox">
        <div class="login-test">商家登录</div>
        <div class="login-testline"></div>
      </div>

      <div class="login_from">
        <img class="login-icon" src="../../../static/zhanghao.png" />
        <input class="login_input" type='number' maxlength='11' placeholder="请输入您的商家账号" v-model="phoneNum" />
      </div>
      <div class="login_from">
        <img class="login-icon" src="../../../static/mima.png" />
        <input class="login_input" type="password" placeholder="请输入您的商家密码" v-model="password" />
      </div>
      <!-- <div class="login_checkbox">
        <img :src="annualReview ? '/static/checked.png' : '/static/check.png'" class="login_checkicon" @click="isReview"></image>
        <div class="login_text">跟单员</div>
      </div> -->
      <div class="addbottonLogin" @click="submit">登录</div>
      <!-- <div class="login_bottom">
        <button class="login_button" type="primary" @click="submit">验证</button>
      </div> -->
    </div>
  </div>
</template>

<script>
  import httper from '../../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        phoneNum: "",
        password: "",
        annualReview: false //是否为跟单员
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      //输入手机号
      // getphone: function(e) {
      //   var value = e.detail.value;
      //   var len = parseInt(value.length);

      //   //最多字数限制
      //   if (len > 11) return;
      //   this.setData({
      //     phoneNum: value
      //   })
      // },
      //输入密码
      // getpassword: function(e) {
      //   var value = e.detail.value;
      //   this.setData({
      //     password: value
      //   })
      // },
      //是否为跟单员
      isReview: function() {
        if (this.annualReview) {
          this.annualReview = false
        } else {
          this.annualReview = true
        }

      },
      submit: function() {
        var that = this
        var phoneNum = that.phoneNum
        // || !(/^1[3456789]\d{9}$/.test(phoneNum))
        if (!phoneNum) {
          this.$toast({
            message: '请输入手机号',
          })
          return
        }

        var password = that.password
        if (!password) {
          this.$toast({
            message: '请输入密码',
          })
          return
        }
        let requestData = {}
        if (this.annualReview) {
          requestData = {
            mobile: phoneNum,
            password: password,
            type: "annual_review"
          }
        } else {
          requestData = {
            mobile: phoneNum,
            password: password
          }
        }
        this.request("userBind", requestData)

      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //用户信息
          case 'userBind':
            httper.post('user/bind', requestData, function(res) {
              if (res.code == 0) {
                that.$toast({
                  message: '验证成功',
                })
                that.request("userInfo")
              } else {
                that.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true)
            break
            //获取用户信息
          case 'userInfo':
            httper.get('wechat/user/info', requestData, function(res) {
              if (res.code == 0) {
                localStorage.removeItem('userinfo');
                localStorage.setItem('userinfo', JSON.stringify(res.data));
                that.$router.push({
                  path: "/"
                })
              } else {
                this.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true)
            break
        }
      },


      // switch (true) {
      //   case res.data.type == 1 || res.data.type == 2:
      //     setTimeout(() => {
      //       wx.reLaunch({
      //         url: '../index/index'
      //       })
      //     }, 500)
      //     break
      //   case res.data.type == 3:
      //     // sessionStorage.setItem("",)
      //     setTimeout(() => {
      //       wx.redirectTo({
      //         url: '../indextwo/indextwo'
      //       })
      //     }, 500)
      //     break
      //   case res.data.type == 5:
      //     setTimeout(() => {
      //       wx.redirectTo({
      //         url: '../reviewIndex/reviewIndex'
      //       })
      //     }, 500)
      //     break
      //   default:
      //     wx.showToast({
      //       title: '验证失败'
      //     })
      // }
      // Dialog.confirm({
      //     title: '提示',
      //     message: '请先绑定手机',
      //   })
      //   .then(() => {
      //     that.$router.push({
      //       path: "/changePhoneNum"
      //     })
      //   })
      //   .catch(() => {
      //     return false;
      //   });
    }
  }
</script>

<style scoped="scoped">
  .login {
    width: 100%;

    position: absolute;
    top: 50px;

  }

  input {
    text-align: left;
  }

  input::-webkit-input-placeholder {
    text-align: left;
    color: #BBBBBB;
    font-size: 14px;
  }

  .login_top {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .login_topimg {
    width: 150px;
    height: 150px;
  }

  .login_name {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .login_from {
    width: calc(100% - 40px);
    margin: 20px;
    border: 1px solid #3157A3;
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login_input {
    width: calc(100% - 30px);
    border-radius: 10px;
    height: 46px;
    background-color: #fff;
    font-size: 18px;
    text-align: left;
    
  }
.login-icon{
  width: 23px;
  height: 23px;
  margin-right: 7px;
}
  .login_bottom {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login_button {
    background-color: red;
    color: #fff;
    width: 60%;
    height: 40px;
    text-align: center;
  }

  .login_checkbox {
    display: flex;
    align-items: center;
    width: calc(100% - 40px);
    margin: 10px 20px;
  }

  .login_checkicon {
    width: 15px;
    height: 15px;
    margin-right: 10px;
  }

  .login_text {
    font-size: 14px;
  }

  .testbox {
    width: calc(100% - 40px);
    margin: 20px;
  }

  .login-test {
    font-weight: bold;
    font-size: 23px;
    color: #3157A3;
    padding-bottom: 15px;
  }

  .login-testline {
    width: 31px;
    height: 4px;
    background: #3157A3;
  }

  .addbottonLogin {
    width: calc(100% - 40px);
    margin: 20px;
    height: 48px;
    background: #3157A3;
    box-shadow: 0px 4px 5px 2px rgba(49, 87, 163, 0.3);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/signIn.vue